module.exports = __webpack_public_path__ + "img/logo.03a717b9.png";